export default "__VITE_ASSET__Cj5VwS6h__"